import { OrderChargeType, OrderPaymentType } from "Infrastructure/Api/Api";
import type {
	Form,
	Mutation,
	SelectOptions,
	Shared,
	ValidationMessages,
} from "Infrastructure/Translation/Types/payment";

const mutationTranslation: Mutation = {
	createPaymentError: "Failed to create payment",
	createPaymentSuccess: "Payment created successfully",
	updatePaymentError: "Failed to update payment",
	updatePaymentSuccess: "Payment updated successfully",
	deletePaymentError: "Failed to delete payment",
	deletePaymentSuccess: "Payment deleted successfully",
	updateOrderFeeError: "Failed to update order fee",
	updateOrderFeeSuccess: "Order fee updated successfully",
	createChargeMutationError: "Failed to create charge",
	createChargeMutationSuccess: "Charge created successfully",
	updateChargeMutationError: "Failed to update charge",
	updateChargeMutationSuccess: "Charge updated successfully",
	deleteChargeMutationError: "Failed to delete charge",
	deleteChargeMutationSuccess: "Charge deleted successfully",
};

const validationMessagesTranslation: ValidationMessages = {
	dateCreated: "Date created is required",
	type: "Type is required",
	amount: "Amount is required",
};

const formTranslations: Form = {
	dateCreated: "Date created",
	type: "Type",
	amount: "Amount",
	responsiblePartner: "Responsible partner",
	differentResponsiblePartner: "Differs from current order partner",
};

const sharedTranslations: Shared = {
	addPayment: "Add payment",
	paymentDetails: "Payments",
	paymentProgress: "Payment progress",
	totalPaid: "Total paid",
	depositPaid: "Deposit paid",
	totalDeposit: "Required deposit",
	total: "Total",
	fees: "Fees",
	discount: "Covered by Adam",
	serviceFeePercentage: "Service fee",
	serviceFeeAmount: "Service fee",
	serviceFeeVATPercentage: "Service fee VAT",
	serviceFeeDiscountPercentage: "Service fee discount",
	serviceVATAmount: "Service VAT",
	customerVATPercentage: "Customer VAT",
	customerVATAmount: "Customer VAT",
	depositPercentage: "Deposit",
	partnerDue: "Partner due",
	otherCharges: "Other fees",
	customerDebt: "Customer debt",
	serviceFeeDiscount: "Service fee discount",
	distribution: "Distribution",
	crossOrderCharges: "Cross-order charges",
	recoveredFrom: "Charge recovered from order",
	deductionForCharge: "Deduction for charge on order",
	deductedFromOrder: "Deducted charge from order",
	partner: "Partner",
	save: "Save",
	addCharge: "Add charge",
	chargeDetails: "Charges",
};

const selectOptionsTranslations: SelectOptions = {
	paymentType: {
		[OrderPaymentType.directPayment]: "Direct payment",
		[OrderPaymentType.orderPayment]: "Order payment",
		[OrderPaymentType.orderDepositPayment]: "Order deposit payment",
		[OrderPaymentType.partnerPayout]: "Partner payout",
	},
	chargeType: {
		[OrderChargeType.other]: "Other",
		[OrderChargeType.express_payment]: "Express payment",
		[OrderChargeType.communication]: "Communication",
		[OrderChargeType.agreed_details]: "Agreed details",
		[OrderChargeType.behaviour_to_customer]: "Behaviour to customer",
		[OrderChargeType.behaviour_to_adam]: "Behaviour to Adam",
		[OrderChargeType.claim]: "Claim",
		[OrderChargeType.connecting_with_customer]: "Connecting with customer",
		[OrderChargeType.delaying_jobs]: "Delaying jobs",
		[OrderChargeType.order_form]: "Order form",
	},
};

export const paymentTranslations = {
	mutation: mutationTranslation,
	validationMessages: validationMessagesTranslation,
	form: formTranslations,
	shared: sharedTranslations,
	selectOptions: selectOptionsTranslations,
};
